import type { TaskActionLog, TaskRecord } from '../types'

function hoursAgo(hours: number) {
  const date = new Date()
  date.setHours(date.getHours() - hours)
  return date.toISOString()
}

function hoursLater(hours: number) {
  const date = new Date()
  date.setHours(date.getHours() + hours)
  return date.toISOString()
}

export const DEFAULT_MOCK_TASKS: TaskRecord[] = [
  {
    id: 't1',
    title: '计件报工待审批',
    description: '张三提交 2026-06-30 白班计件，共 12 条明细待核对。',
    status: 'pending',
    priority: 'urgent',
    module: 'mes',
    bizType: 'piece-report',
    assignee: '李主管',
    creator: '张三',
    dueTime: hoursLater(4),
    createTime: hoursAgo(2),
    bizTab: 'piece',
    payload: { reportDate: '2026-06-30', shift: 'day' },
  },
  {
    id: 't2',
    title: '工序父级关系变更确认',
    description: '工序「钻孔」申请绑定父工序，需工艺员确认。',
    status: 'processing',
    priority: 'high',
    module: 'mes',
    bizType: 'process-change',
    assignee: '王工艺',
    creator: '系统',
    dueTime: hoursLater(24),
    createTime: hoursAgo(6),
    bizTab: 'process',
    payload: { processCode: 'DRILL-01' },
  },
  {
    id: 't3',
    title: '用户批量导入复核',
    description: '人事部上传 28 条用户 Excel，需确认必填项与部门映射。',
    status: 'pending',
    priority: 'normal',
    module: 'system',
    bizType: 'user-import',
    assignee: '李主管',
    creator: '赵人事',
    dueTime: hoursLater(48),
    createTime: hoursAgo(12),
    bizTab: 'user',
    payload: { importCount: 28 },
  },
  {
    id: 't4',
    title: 'LOV 字典「工序类型」待发布',
    description: '新增枚举值「外协」后需发布到生产环境。',
    status: 'overdue',
    priority: 'high',
    module: 'system',
    bizType: 'lov-publish',
    assignee: '李主管',
    creator: '王工艺',
    dueTime: hoursAgo(8),
    createTime: hoursAgo(30),
    bizTab: 'lov',
  },
  {
    id: 't5',
    title: '菜单权限调整申请',
    description: '为「质检组」开放计件查询菜单，已完成审批。',
    status: 'done',
    priority: 'low',
    module: 'system',
    bizType: 'menu-permission',
    assignee: '李主管',
    creator: '系统',
    createTime: hoursAgo(48),
    bizTab: 'menu',
  },
]

export const DEFAULT_MOCK_ACTION_LOGS: Record<string, TaskActionLog[]> = {
  t1: [
    {
      time: hoursAgo(2),
      operator: '张三',
      action: '提交报工',
      remark: '白班 12 条',
    },
    {
      time: hoursAgo(2),
      operator: '系统',
      action: '生成待办',
      remark: '流转至李主管',
    },
  ],
  t2: [
    { time: hoursAgo(6), operator: '系统', action: '发起变更' },
    { time: hoursAgo(5), operator: '王工艺', action: '开始处理' },
  ],
  t3: [{ time: hoursAgo(12), operator: '赵人事', action: '上传导入文件' }],
  t4: [
    { time: hoursAgo(30), operator: '王工艺', action: '提交发布申请' },
    { time: hoursAgo(8), operator: '系统', action: '标记逾期' },
  ],
  t5: [
    { time: hoursAgo(48), operator: '系统', action: '创建任务' },
    { time: hoursAgo(47), operator: '李主管', action: '审批通过' },
    { time: hoursAgo(46), operator: '李主管', action: '完成任务' },
  ],
}
